document.addEventListener("DOMContentLoaded", function () {
  const triggers = {
    PLUS: ".product-quantity-selector__plus",
    MINUS: ".product-quantity-selector__minus",
    QUANTITY_SELECTOR: ".product-quantity-selector__quantity",
    QUANTITY_INPUT: "[data-cart-quantity]",
    COLOR_SELECTOR: ".color-selector",
    COLOR_SELECTOR_CLOSE: ".color-selector__close",
    COLOR_SELECTOR_POPUP: ".color-selector__options",
    COLOR_SELECTOR_OVERLAY: ".color-selector__overlay",
    COLOR_SELECTOR_OPTION: ".color-selector__option",
    THUMBNAIL: ".product-images__alternative",
    CART_ID: "[data-cart-id]",
  };

  document.addEventListener("click", function (e) {
    if (e.target.closest(triggers.MINUS)) {
      handleQuantityChange(-1);
    }

    if (e.target.closest(triggers.PLUS)) {
      handleQuantityChange(1);
    }

    if (e.target.closest(triggers.THUMBNAIL)) {
      const currentImage = document.querySelector(
        ".product-images__featured-image > img.visible"
      );
      const clickedImage = e.target.closest(triggers.THUMBNAIL);

      if (clickedImage.dataset.variantSku === currentImage.dataset.variantSku)
        return;

      currentImage.classList.toggle("visible");
      document
        .querySelector(
          `.product-images__featured-image > img[data-variant-sku='${clickedImage.dataset.variantSku}']`
        )
        .classList.toggle("visible");
    }

    if (e.target.closest(triggers.COLOR_SELECTOR_OPTION)) {
      const clickedOption = e.target.closest(triggers.COLOR_SELECTOR_OPTION);

      if (clickedOption.matches(".selected")) return;

      const selected = document.querySelector(
        `${triggers.COLOR_SELECTOR_OPTION}.selected`
      );
      selected && selected.classList.toggle("selected");
      clickedOption.classList.toggle("selected");
      document.querySelector(triggers.CART_ID).value = clickedOption.dataset.id;

      let selectedImage = document.querySelector(
        ".color-selector .color-selector__image img"
      );
      let selectedTitle = document.querySelector(
        ".color-selector .color-selector__variant-title"
      );

      let clickedImage = clickedOption
        .querySelector(".color-selector__image img")
        .cloneNode();
      let clickedTitle = clickedOption.querySelector(
        ".color-selector__variant-title"
      );

      selectedImage = document
        .querySelector(".color-selector .color-selector__image")
        .replaceChild(clickedImage, selectedImage);
      selectedTitle.textContent = clickedTitle.textContent;

      document
        .querySelector(triggers.COLOR_SELECTOR_OVERLAY)
        .classList.toggle("visible");
      document
        .querySelector(triggers.COLOR_SELECTOR_POPUP)
        .classList.toggle("visible");

      const clickedSku = clickedOption.dataset.sku;

      document
        .querySelectorAll(".product-images__alternative.visible")
        .forEach((t) => t.classList.toggle("visible"));
      document
        .querySelectorAll(
          `.product-images__alternative[data-variant-sku*="${clickedSku}-"]`
        )
        .forEach((t) => {
          t.classList.toggle("visible");
        });

      document
        .querySelectorAll(".product-tags.visible")
        .forEach((t) => t.classList.toggle("visible"));
      document
        .querySelectorAll(`.product-tags[data-variant-sku*="${clickedSku}"]`)
        .forEach((t) => {
          t.classList.toggle("visible");
        });

      document
        .querySelectorAll(`.product-images__featured-image > .visible`)
        .forEach((t) => t.classList.toggle("visible"));
      document
        .querySelectorAll(
          `.product-images__featured-image [data-variant-sku*="${clickedSku}-"]`
        )[0]
        .classList.toggle("visible");
      document.body.classList.toggle("color-selector-open");
    }

    if (
      e.target.closest(triggers.COLOR_SELECTOR) ||
      e.target.closest(triggers.COLOR_SELECTOR_CLOSE)
    ) {
      document
        .querySelector(triggers.COLOR_SELECTOR)
        .classList.toggle("with-popup");
      document
        .querySelector(triggers.COLOR_SELECTOR_POPUP)
        .classList.toggle(`visible`);
      document
        .querySelector(triggers.COLOR_SELECTOR_OVERLAY)
        .classList.toggle(`visible`);
      document.body.classList.toggle("color-selector-open");
    }
  });

  function handleQuantityChange(change) {
    const quantitySelector = document.querySelector(triggers.QUANTITY_SELECTOR);
    const quantityInput = document.querySelector(triggers.QUANTITY_INPUT);

    if (quantitySelector) {
      const quantity = parseInt(quantitySelector.textContent) + change;

      quantitySelector.textContent = quantity > 1 ? quantity : 1;
      quantityInput.value = quantity > 1 ? quantity : 1;
    }
  }

  Shopify.queryParams = {};
  if (location.search.length) {
    for (
      var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
      i < aCouples.length;
      i++
    ) {
      aKeyValue = aCouples[i].split("=");
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
          decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  const sortBy = document.querySelector("#sort-by");

  if (sortBy)
    document.querySelector("#sort-by").addEventListener("change", function (e) {
      var value = e.currentTarget.value;
      Shopify.queryParams.sort_by = value;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });
});
